<template>
  <v-app>
      <v-navigation-drawer
        v-model="drawer"
        absolute
        expand-on-hover
        style="z-index: 5;"
      >
        <v-spacer></v-spacer>
        <v-list
          nav
        >
        <div v-if="this.$store.state.user.isLoggedIn" class="pt-12">        

          <v-list-item-group 
            active-class="text--accent-4"
          >
            <router-link v-for="e in menu" :key="e.title" :to="e.path"  style="text-decoration: none; color: inherit;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>{{ e.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ e.title }}</v-list-item-title>
            </v-list-item>
            </router-link>
          </v-list-item-group>
          </div>

          <div v-if="this.$store.state.user.isLoggedIn && (this.$store.state.user.isCampMaster)">
          <br />
          <hr />
          <br />

          <!-- <v-subheader>Admin Menu</v-subheader> -->

          <v-list-item-group 
            active-class="text--accent-4"
          >
           <router-link v-for="e in campMasterMenu" :key="e.title" :to="e.path"  style="text-decoration: none; color: inherit;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>{{ e.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ e.title }}</v-list-item-title>
            </v-list-item>
            </router-link>

          </v-list-item-group>

          </div>

          <div v-if="this.$store.state.user.isLoggedIn && this.$store.state.user.isAdmin">
          <br />
          <hr />
          <br />

          <!-- <v-subheader>Admin Menu</v-subheader> -->

          <v-list-item-group 
            active-class="text--accent-4"
          >
           <router-link v-for="e in adminMenu" :key="e.title" :to="e.path"  style="text-decoration: none; color: inherit;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>{{ e.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ e.title }}</v-list-item-title>
            </v-list-item>
            </router-link>

          </v-list-item-group>

          </div>

          <div v-if="this.$store.state.user.isLoggedIn">
          <br />
          <hr />
          <br />

          <v-list-item-group 
            active-class="text--accent-4"
          >
           <router-link v-for="e in weatherMenu" :key="e.title" :to="e.path"  style="text-decoration: none; color: inherit;">
            <v-list-item>
              <v-list-item-icon>
                <v-icon>{{ e.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ e.title }}</v-list-item-title>
            </v-list-item>
            </router-link>

          </v-list-item-group>
          </div>


        </v-list>
      </v-navigation-drawer>

    <v-app-bar app
      dense
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="this.$store.state.user.isLoggedIn"></v-app-bar-nav-icon>

      <v-toolbar-title>Εφαρμογή Ασφαλείας | {{ this.$route.name }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <p class="mt-4" v-if="this.$store.state.user.isLoggedIn">
        [{{ this.displayRole }}] - {{ this.$store.state.user.username }} - {{ this.$store.state.user.email }}
      </p>

    <v-menu v-if="this.$store.state.user.isLoggedIn"
            left
            bottom
            style="z-index: 1000"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="logout">
                <v-list-item-title>Αποσύνδεση</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

    </v-app-bar>

    <v-main>
      <v-container fluid class="px-0 mt-0 pt-0">
          <router-view :class="$route.path === '/' ? 'ml-4' : 'ml-16'" style="z-index: 0;"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  methods: {
    logout() {
      this.$store.dispatch('user/logout')
      this.$router.replace('/login')
    }
  },
  computed: {
    displayRole() {
      var isAdmin = this.$store.state.user.isAdmin
      var isCampMaster = this.$store.state.user.isCampMaster
      
      if (isAdmin && isCampMaster) {
        return "superadmin"
      }

      if (isAdmin) {
        return "admin"
      }

      if (isCampMaster) {
        return "campmaster"
      }

      return "user"
    }
  },
  data: () => {
    return {
      drawer: false,
      menu: [
        {
          title: "Αρχική",
          icon: "mdi-home",
          path: "/"
        },
        {
          title: "Λογαριασμός",
          icon: "mdi-account",
          path: "/users/me"
        },
        {
          title: "Αισθητήρες",
          icon: "mdi-motion-sensor",
          path: "/browse/sensors"
        },
        {
          title: "Συμβάντα",
          icon: "mdi-view-list",
          path: "/browse/events"
        },
      ],
      campMasterMenu: [
        {
          title: "Διαχείρηση Περιοχών",
          icon: "mdi-campfire",
          path: "/admin/camps"
        }
      ],
      adminMenu: [
        {
          title: "Διαχείρηση Χρηστών",
          icon: "mdi-account-group",
          path: "/admin/users"
        },
        // {
        //   title: "Προσθήκη Αισθητήρα",
        //   icon: "mdi-leak",
        //   path: "/sensors/create"
        // }
      ],
      weatherMenu: [
        {
          title: "Σταθμοί Καιρού",
          icon: "mdi-space-station",
          path: "/browse/weatherStations"
        },
        {
          title: "Ενημερώσεις Καιρού",
          icon: "mdi-weather-lightning",
          path: "/browse/weatherUpdates"
        },
      ]
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
